import axiosFactory from "./axios.factory";

class GeneralCostsService {
  async getGeneralCosts() {
    const result = await axiosFactory().get("/general_costs");
    return result.data.data;
  }

  async saveGeneralCosts(updates) {
    const result = await axiosFactory().put("/general_costs", updates);
    return result.data.data;
  }
}

export default new GeneralCostsService();
